module.exports = "/_next/static/images/2a217e61eaf8137a8f110663dc94369e-2-cards@0.5x.jpg.webp";